import { Article } from "../Article/Article.js";
var article = new Article();
window.article = article;

import { Auth } from "../Auth/Auth.js";
var auth = new Auth();
window.auth = auth;

import { Opros } from "../Opros/Opros.js";
var opros = new Opros();
window.opros = opros;

// App heights
const doc = document.documentElement
const header = document.querySelector(".header");
const appHeights = () => {
	if (header) {
		let headerHeight = header.offsetHeight;
		doc.style.setProperty('--header-height', headerHeight + "px");
	}
}
appHeights();


function setcookie(name, value, expires, path, domain, secure) {
	expires instanceof Date ? expires = expires.toGMTString() : typeof (expires) == 'number' && (expires = (new Date(+(new Date) + expires * 1e3)).toGMTString());
	var r = [name + "=" + escape(value)], s, i;
	for (i in s = { expires: expires, path: path, domain: domain }) {
		s[i] && r.push(i + "=" + s[i]);
	}
	return secure && r.push("secure"), document.cookie = r.join(";"), true;
}

function getcookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	))
	return matches ? decodeURIComponent(matches[1]) : undefined
}

if (!getcookie('cookieAccepted')) {
	$(".cookie").addClass('active');
}

$('.cookie__btn').on("click", function () {
	setcookie('cookieAccepted', 1, 60 * 60 * 24 * 365, '/');
	$(".cookie").removeClass('active');
});


// Burger
$(".header__burger").on("click", function () {
	$("body").toggleClass("no-scroll");
	$(this).toggleClass("active");
	$(".header__general").toggleClass("active");
});


// Auth popup
$(".header__auth-btn--auth, .new-comment__auth-btn").on("click", function () {
	$(".auth-popup").toggleClass("active");
});

$(".auth-popup__close").on("click", function () {
	$(".auth-popup").removeClass("active");
});


// popup mobile
const headerMain = document.querySelector(".header__main");
const headerAdditional = document.querySelector(".header__additional");
const headerGeneral = document.querySelector(".header__general");
function headerGeneralHeightCalc() {
	let headerMainHeight = headerMain.getBoundingClientRect().height;
	let headerAdditionalRectBottom = headerAdditional.getBoundingClientRect().bottom;
	headerGeneral.style.top = (headerMainHeight + headerAdditionalRectBottom) + "px";
	headerGeneral.style.height = "calc(100vh - " + (headerMainHeight + headerAdditionalRectBottom) + "px)";
};
if (!window.matchMedia("(min-width: 1024px)").matches) {
	headerGeneralHeightCalc();
}


// Resize
$(window).on("resize", function () {
	appHeights();

	if (!window.matchMedia("(min-width: 1024px)").matches) {
		headerGeneralHeightCalc();
	} else {
		headerGeneral.style.top = null;
		headerGeneral.style.height = null;
	}

	// textarea autoheight
	$(".form__textarea--autoheight").each(function () {
		this.style.height = 'auto';
		this.style.height = (this.scrollHeight) + 2 + 'px';
	});
});


// textarea autoheight
$(".form__textarea--autoheight").each(function () {
	this.style.height = 'auto';
	this.style.height = (this.scrollHeight) + 2 + 'px';
});
$('.form__textarea--autoheight').on('input', function () {
	this.style.height = 'auto';
	this.style.height = (this.scrollHeight) + 2 + 'px';
});

// Get the element
const toTopBtn = document.querySelector(".to-top");

// On Click, Scroll to the page's top, replace 'smooth' with 'instant' if you don't want smooth scrolling
toTopBtn.onclick = () => window.scrollTo({ top: 0, behavior: "smooth" });

// On scroll, Show/Hide the btn with animation
window.onscroll = () => toTopBtn.style.opacity = window.scrollY > 500 ? 1 : 0;


// Scroll
$(window).on("scroll", function () {
	if ($(this).scrollTop() > 2000) {
		$('.to-top').addClass('active');
	} else {
		$('.to-top').removeClass('active');
	}

	if (!window.matchMedia("(min-width: 1024px)").matches) {
		headerGeneralHeightCalc();
	}
})


$(document).on("ready", function () {
	appHeights();
});


$(document).on("click", function (e) {
	if ($(".auth-popup").hasClass("active")) {
		var callbackPopup = $(".auth-popup, .header__auth-btn--auth, .new-comment__auth-btn");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".auth-popup").removeClass("active");
		};
	}

	if ($(".p-plus__overflow").is(":visible") && typeof inst !== 'undefined') {
		var callbackPopup = $(".p-plus__toggle-btn, .p-plus__overflow");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			inst.setOverflowNavOpen(false);
		};
	}

	// Publications date toggler
	if ($(".publications__date-popup").hasClass("active")) {
		var callbackPopup = $(".publications__date-popup, .publications__date-toggler, .flatpickr-calendar");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".publications__date-popup").removeClass("active");
		};
	}

	// Article share
	if ($(".article__share-list").hasClass("active")) {
		var callbackPopup = $(".article__share-toggler, .article__share-list");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".article__share-list").removeClass("active");
		};
	}
});


// priority plus
var inst;
if ($(".js-p-target").length) {
	inst = priorityPlus(document.querySelector('.js-p-target'), {
		innerToggleTemplate: "Ещё",
	});
}


// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	$("body").addClass("no-scroll");
	$(".popup[data-popup-name=" + dataPopupName + "]").addClass("active");
});

$("[data-popup-open='popup-image']").on("click", function () {
	let dataImageSrc = $(this).attr("href");
	let dataImageCaption = $(this).attr("data-image-caption");
	$(".popup-image__image").attr("src", dataImageSrc);
	$(".popup-image__figcaption").html(dataImageCaption);
});


// STICKY SIDEEARS 1
// if (window.matchMedia("(min-width: 768px)").matches && !window.matchMedia("(min-width: 1024px)").matches) {
// 	if ($('.asides-wrapper').length) {
// 		var sidebarCommon = new StickySidebar('.asides-wrapper', {
// 			resizeSensor: true,
// 			minWidth: 767,
// 			topSpacing: 84,
// 			bottomSpacing: 24,
// 			containerSelector: '.split-wrapper',
// 			innerWrapperSelector: '.asides-wrapper__inner',
// 		});
// 	}
// 	if ($('.main').length) {
// 		var sidebarRight = new StickySidebar('.main', {
// 			resizeSensor: true,
// 			minWidth: 1023,
// 			topSpacing: 148,
// 			bottomSpacing: 32,
// 			containerSelector: '.split-wrapper',
// 			innerWrapperSelector: '.aside__inner',
// 		});
// 	}
// }
// if (window.matchMedia("(min-width: 1024px)").matches) {
// 	if ($('.aside-left').length) {
// 		var sidebarLeft = new StickySidebar('.aside-left', {
// 			resizeSensor: true,
// 			minWidth: 1023,
// 			topSpacing: 148,
// 			bottomSpacing: 32,
// 			containerSelector: '.split-wrapper',
// 			innerWrapperSelector: '.aside__inner',
// 		});
// 	}
// 	if ($('.aside-right').length) {
// 		var sidebarRight = new StickySidebar('.aside-right', {
// 			resizeSensor: true,
// 			minWidth: 1023,
// 			topSpacing: 148,
// 			bottomSpacing: 32,
// 			containerSelector: '.split-wrapper',
// 			innerWrapperSelector: '.aside__inner',
// 		});
// 	}
// 	if ($('.main').length) {
// 		var sidebarRight = new StickySidebar('.main', {
// 			resizeSensor: true,
// 			minWidth: 1023,
// 			topSpacing: 148,
// 			bottomSpacing: 32,
// 			containerSelector: '.split-wrapper',
// 			innerWrapperSelector: '.aside__inner',
// 		});
// 	}
// }

// STICKY SIDEEARS 2
document.addEventListener('DOMContentLoaded', function () {
	var sidebarCommon = new hcSticky('.asides-wrapper__inner', {
		disable: true,
		stickTo: '.split-wrapper',
		mobileFirst: true,
		responsive: {
			768: {
				disable: false,
				top: 80,
				bottom: 20,
			},
			1024: {
				top: 119,
				bottom: 20,
			},
			1280: {
				disable: true,
			},
		}
	});
	var sidebarMain = new hcSticky('.main__inner', {
		disable: true,
		stickTo: '.split-wrapper',
		mobileFirst: true,
		responsive: {
			768: {
				disable: false,
				top: 80,
				bottom: 20,
			},
			1024: {
				top: 119,
				bottom: 20,
			},
			1440: {
				top: 129,
				bottom: 24,
			},
			1680: {
				top: 144,
				bottom: 28,
			},
			1768: {
				top: 157,
				bottom: 32,
			},
		}
	});
	var sidebarLeft = new hcSticky('.aside-left .aside__inner', {
		disable: true,
		stickTo: '.split-wrapper',
		mobileFirst: true,
		responsive: {
			1280: {
				disable: false,
				top: 119,
				bottom: 20,
			},
			1440: {
				top: 129,
				bottom: 24,
			},
			1680: {
				top: 144,
				bottom: 28,
			},
			1768: {
				top: 157,
				bottom: 32,
			},
		}
	});
	var sidebarRight = new hcSticky('.aside-right .aside__inner', {
		disable: true,
		stickTo: '.split-wrapper',
		mobileFirst: true,
		responsive: {
			1280: {
				disable: false,
				top: 119,
				bottom: 20,
			},
			1440: {
				top: 129,
				bottom: 24,
			},
			1680: {
				top: 144,
				bottom: 28,
			},
			1768: {
				top: 157,
				bottom: 32,
			},
		}
	});
});


// swiper sliders
const asideSlider = document.querySelector(".aside-slider")
if (asideSlider) {
	let asideSwiper = new Swiper('.aside-slider', {
		modules: [Navigation, Pagination, Autoplay],
		slidesPerView: 1,
		spaceBetween: 16,
		loop: true,
		autoplay: {
			delay: 10000,
		},
		pagination: {
			el: '.aside-slider__pagination',
			clickable: true
		},
		navigation: {
			nextEl: '.aside-slider__nav-btn--next',
			prevEl: '.aside-slider__nav-btn--prev'
		},
	});
	$(".aside-slider").on("hover", function () {
		(this).swiper.autoplay.stop();
	}, function () {
		(this).swiper.autoplay.start();
	});
}

const publicationsPopularSlider = document.querySelector(".publications-popular__slider")
if (publicationsPopularSlider) {
	let publicationsPopularSwiper = new Swiper('.publications-popular__slider', {
		modules: [Navigation, Pagination],
		slidesPerView: 'auto',
		spaceBetween: 16,
		pagination: {
			el: '.publications-popular__slider-pagination',
			clickable: true
		},
		breakpoints: {
			1024: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 20
			},
			1280: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
			1440: {
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 24
			},
			1680: {
				slidesPerView: 5,
				slidesPerGroup: 5,
				spaceBetween: 24
			},
			1680: {
				slidesPerView: 5,
				slidesPerGroup: 5,
				spaceBetween: 32
			},
		},
		navigation: {
			nextEl: '.publications-popular__slider-nav-btn--next',
			prevEl: '.publications-popular__slider-nav-btn--prev'
		}
	});
}

const articleGallery = document.querySelector(".article-gallery")
if (articleGallery) {
	let articleGalleryThumbs = new Swiper('.article-gallery__thumbs-wrapper', {
		modules: [Navigation],
		slidesPerView: "auto",
		spaceBetween: 8,
		watchSlidesProgress: true,
		watchSlidesVisibility: true,
		slideToClickedSlide: true,
		navigation: {
			nextEl: '.article-gallery__thumbs-nav--next',
			prevEl: '.article-gallery__thumbs-nav--prev'
		},
	});

	let articleGalleryMain = new Swiper('.article-slider', {
		modules: [Navigation, Thumbs],
		slidesPerView: 1,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '.article-slider__nav-btn--next',
			prevEl: '.article-slider__nav-btn--prev'
		},
		thumbs: {
			swiper: articleGalleryThumbs
		}
	});

	if (articleGalleryMain.controller) {
		articleGalleryMain.controller.control = articleGalleryThumbs;
	}
}


// Events calendar
$(".calendar-table__months-toggler").on("click", function (e) {
	$(this).toggleClass("active");
	$(this).siblings(".calendar-table__days-list").slideToggle();
});


// Comments
$(".comment__reply--main").on("click", function () {
	$(this).closest(".comment__container").siblings(".comment__replies").find(".comment__replies-new").slideDown(400)
		.find(".new-comment__textarea").focus();

	setTimeout(() => {
		$(".form__textarea--autoheight").each(function () {
			this.style.height = 'auto';
			this.style.height = (this.scrollHeight) + 2 + 'px';
		});
	}, 400);
})
$(".comment__reply--inner").on("click", function () {
	$(this).closest(".comment__replies").find(".comment__replies-new").slideDown(400)
		.find(".new-comment__textarea").focus();

	setTimeout(() => {
		$(".form__textarea--autoheight").each(function () {
			this.style.height = 'auto';
			this.style.height = (this.scrollHeight) + 2 + 'px';
		});
	}, 400);
})


// Article share
$(".article__share-toggler").on("click", function () {
	$(".article__share-toggler").not(this).siblings(".article__share-list").removeClass("active");
	$(this).siblings(".article__share-list").toggleClass("active");
});

// Copy article url
$(".article__share-btn--copy").on("click", function () {
	let url = document.location.href;
	navigator.clipboard.writeText(url);
	$(this).siblings(".article__share-copied").addClass("active");
	setTimeout(() => {
		$(this).siblings(".article__share-copied").removeClass("active");
	}, 2000);
});


// Publications top toggler
$(".publications__top-toggler").on("click", function (e) {
	$(this).toggleClass("active");
	$(".publications__date-search, .publications__tags").slideToggle();
});


// Publications date toggler
$(".publications__date-toggler").on("click", function (e) {
	$(".publications__date-popup").toggleClass("active");
});


// Orgs filter
$(".organizations__filter-input").on("change", function () {
	let activeInputName = $(".organizations__filter-input:checked").val();
	$(".organizations__tab").hide();
	$(".organizations__tab[data-table-name=" + activeInputName + "]").fadeIn();
});


// DATES
const Russian = require("flatpickr/dist/l10n/ru.js").default.ru;

// flatpickrs date simple
flatpickr(".form__date-input--simple", {
	dateFormat: "d.m.Y",
	"locale": Russian,
});

// flatpickrs date multiple
flatpickr(".form__date-input--multiple", {
	mode: "multiple",
	dateFormat: "d.m.Y",
	"locale": Russian,
});

// flatpickrs date range
flatpickr(".form__date-input--range", {
	mode: "range",
	dateFormat: "d.m.Y",
	"locale": Russian,
});

// flatpickrs time simple
flatpickr(".form__time-input--simple", {
	enableTime: true,
	noCalendar: true,
	dateFormat: "H:i",
	time_24hr: true,
	"locale": Russian,
});

document.querySelector(".subscription-aside__form-submit").addEventListener("click", function (e) {
	e.preventDefault();
	subscribe3(".subscription-aside__form");
});

function subscribe3(parent) {
	var el = $(parent);
	var emailInput = el.find(".subscription-aside__form-input");
	var emailInputValue = emailInput.val();
	var button = el.find("button");

	if (!emailInputValue)
		return;
	else {
		button.attr('disabled', 'disabled');

		let recpatchaSelector = document.querySelector('meta[name="captcha"]');
		if (recpatchaSelector) {
			let recpatchaKey = recpatchaSelector.content;
			grecaptcha.ready(function () {
				grecaptcha.execute(recpatchaKey, { action: 'submit' }).then(function (token) {
					$.ajax({
						url: "/ajax.php?mid=18",
						type: 'POST',
						data: {
							email: emailInputValue,
							token: token
						},
						dataType: "json",
						success: function (res) {
							if (res['success']) {
								var text = res['text'];
								el.append('<p>' + text + '</p>');
								button.fadeOut();
								emailInput.fadeOut();
								resolve(res);
							} else {
								button.attr('disabled', false);
								reject('Ошибка: ' + res['text']);
							}
						},
						error: function (res) {
							button.attr('disabled', false);
							reject('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
						}
					});
				});
			});
		} else {
			$.ajax({
				url: "/ajax.php?mid=18",
				type: 'POST',
				data: {
					email: emailInputValue
				},
				dataType: "json",
				success: function (res) {
					if (res['success']) {
						var text = res['text'];
						el.append('<p>' + text + '</p>');
						button.fadeOut();
						emailInput.fadeOut();
						resolve(res);
					} else {
						button.attr('disabled', false);
						reject('Ошибка: ' + res['text']);
					}
				},
				error: function (res) {
					button.attr('disabled', false);
					reject('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
				}
			});
		}
	}
}


document.addEventListener('DOMContentLoaded', function () {
	// Находим все радио-кнопки внутри блока с классом .form__item--with-own
	const radioButtons = document.querySelectorAll('.form__item--with-own .form__radio-input');

	radioButtons.forEach(radioButton => {
		radioButton.addEventListener('change', function () {
			// Проверяем, есть ли у текущего радио-кнопки класс .form-own__radio-input
			if (this.classList.contains('form-own__radio-input')) {
				// Если это радио с классом .form-own__radio-input
				const formOwn = this.closest('.form-own');

				// Если родительский элемент .form-own найден
				if (formOwn) {
					const ownItem = formOwn.querySelector('.form-own__item');
					if (ownItem) {
						ownItem.classList.add('active');
					}
				}
			} else {
				// Если это обычная радио-кнопка (без класса .form-own__radio-input)
				const formOwn = this.closest('.form__item--with-own');
				if (formOwn) {
					const ownItem = formOwn.querySelector('.form-own__item');
					if (ownItem) {
						ownItem.classList.remove('active');
					}
				}
			}
		});
	});
});

$("button.clear-all").on('click', function (){
	const cleanUrl = window.location.origin + window.location.pathname;
	window.history.replaceState({}, document.title, cleanUrl);
	window.location.reload();
})